/**
 * Where a control or an audit stands, in the words /security shows (2026-10-16), read by both designs of the page
 * (src/pages/Security.tsx and src/design/pavilion/pages/security/PavilionSecurity.tsx), so a status means one thing
 * and draws one way on both.
 *
 * Each status has a tone: `done` is in place (or a report issued, or held by Google Cloud underneath us), `underway`
 * is being done or only partly in place (committed, in progress, an audit underway, tested but not reviewed),
 * `planned` is not begun. The page draws a check, a half-filled circle or a dashed one by the tone; the word beside it
 * is what it says. Prest0's own audits take their status from src/config/complianceStatus.generated.ts, whose states
 * are all in this list (tests/landing/securityStatuses.test.ts holds every status both pages show to it).
 *
 * 'tested, not reviewed' (2026-10-16) is change control as it runs: every change passes the required automated checks,
 * and no person has to approve one. Half of the requirement's minimum ("reviewed, tested changes"), so never a check.
 */
export type SecurityTone = 'done' | 'underway' | 'planned';

export const SECURITY_STATUSES: Readonly<Record<string, SecurityTone>> = {
  'in place': 'done',
  'report issued': 'done',
  'held by google': 'done',
  committed: 'underway',
  'in progress': 'underway',
  'audit underway': 'underway',
  'tested, not reviewed': 'underway',
  planned: 'planned',
};

/** The tone of a status (one outside the list reads as planned, the least it could claim). */
export const toneOf = (status: string): SecurityTone => SECURITY_STATUSES[status] ?? 'planned';
